import React from "react";
import { Modal } from "antd";
import "./ChatMentionNavigateModal.css";

/** 群聊 @产品：苹果风格确认弹框 */
export function showChatMentionNavigateModal(options: {
  productName: string;
  onConfirm: () => void;
}): void {
  const name = options.productName.trim() || "该产品";
  const modal = Modal.info({
    className: "lf-h5-ios-alert",
    icon: null,
    centered: true,
    width: 270,
    closable: false,
    maskClosable: true,
    footer: null,
    content: (
      <div className="lf-h5-ios-alert__card">
        <div className="lf-h5-ios-alert__body">
          <p className="lf-h5-ios-alert__title">前往「{name}」？</p>
          <p className="lf-h5-ios-alert__message">是否离开当前页面，前往「{name}」查看？</p>
        </div>
        <div className="lf-h5-ios-alert__actions">
          <button
            type="button"
            className="lf-h5-ios-alert__btn lf-h5-ios-alert__btn--cancel"
            onClick={() => modal.destroy()}
          >
            留在此页
          </button>
          <button
            type="button"
            className="lf-h5-ios-alert__btn lf-h5-ios-alert__btn--confirm"
            onClick={() => {
              modal.destroy();
              options.onConfirm();
            }}
          >
            前往{name}
          </button>
        </div>
      </div>
    ),
  });
}
